import {useSelector} from "react-redux";
import View from "./View";
import {useEffect, useState} from "react";
import {GAME_STATE, URL} from "utils";
import {getPlayRank, createPlayRank, updatePlayRank} from "api-v3";

export default function Container() {
  const {gameState} = useSelector(state => state.game);
  // const playData = useSelector(state => state.playData);
  const [record, setRecord] = useState(null);

  useEffect(() => {
    if (gameState === GAME_STATE.PLAYING) {
      setRecord(window.performance.now());
    } else if (gameState === "FINISHED") {
      const startTime = record;
      const curRecord = window.performance.now() - startTime - 4000;

      const updateRecord = async record => {
        try {
          getPlayRank({worldType: "RUNNERZ", eventType: "DEFAULT"}).then(body => {
            if (body.code === 0) {
              let tag = "DEFAULT";
              createPlayRank({best: record, worldType: "RUNNERZ", evnetType: "DEFAULT", tag: tag}).then(() => {});
            } else if (body.data.best === null || body.data.best > record) {
              updatePlayRank({worldType: "RUNNERZ", evnetType: "DEFAULT"}, {best: record}).then(() => {});
            }
          });
        } catch (error) {
          console.log(error);
        }
      };

      updateRecord(curRecord);
      setRecord(curRecord);
    }
  }, [gameState]);

  return <View gameState={gameState} record={record} />;
}
